var _excluded = ["data"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import Link from "@nib-components/link";
import { copyFontSizeSmall } from "@nib-components/theme";
import { Inline, Container, breakpoint, mr } from "@nib/layout";
var RibbonWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  color: inherit;\n"])));
var RibbonLinks = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n"])), mr(5), breakpoint("xl", "xxl")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), mr(3)));
export var RibbonLink = styled(Link)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &&& {\n    color: inherit;\n    font-size: ", ";\n  }\n"])), copyFontSizeSmall);

var Ribbon = function Ribbon(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  if (!data || data.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(RibbonWrapper, otherProps, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(RibbonLinks, null, /*#__PURE__*/React.createElement(Inline, {
    space: 3,
    align: "right"
  }, data.map(function (link, i) {
    return /*#__PURE__*/React.createElement(RibbonLink, {
      id: "".concat(link.id, "-desktop"),
      key: "item-".concat(i, "-").concat(link.id, "-desktop"),
      href: link.url,
      title: link.title
    }, link.title);
  })))));
};

export default Ribbon;